export enum BydAuthApiPathsEnum {
  USERS_AUTHENTIFY_V2 = '/users/authentifyv2',
  AUTH_LOGIN_SSO = '/auth/login',
  AUTH_LOGOUT_SSO = '/auth/logout',
  AUTH_REFRESH = '/auth/refresh',
}
